export default __webpack_public_path__ + "static/media/fhm-note.e31fae8b.webp";